import React from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';
import Text from '@tds/core-text';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';

import {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalHeading,
  ButtonContainer
} from './css';

const BrpConfirmationBox = ({ handleSubmitAnotherBrpRequest }) => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push('/');
  };
  return (
    <Backdrop>
      <ModalMain>
        <ModalInner>
          <ModalMessageMain>
            <ModalHeading>Your request has been submitted.</ModalHeading>
            <Box between={2}>
              <HairlineDivider />
              <Text>
                <p style={{ margin: '1rem 0' }}>
                  Thank you for submitting your NTA Request to Business Resource
                  Planning.
                </p>
                <p style={{ margin: '0.5rem 0' }}>
                  Our team is operational Monday-Friday, 8-4pm (MST) (7-3pm
                  (PST)), supporting All TELUS regions, excluding Quebec and
                  Labrador.
                </p>
                <p style={{ margin: '0.5rem 0' }}>
                  You should expect a response to your inquiry within 1 - 2
                  business days.
                </p>
                <p style={{ margin: '0.5rem 0' }}>
                  Should your submission NOT meet the criteria for NBD/BCX
                  Resource planning function, it may be rejected.
                </p>
                <p style={{ margin: '0.5rem 0' }}>
                  For immediate assistance please call 1-855-200-8882 and follow
                  the queue prompts.
                </p>
                <p>TELUS ® BRM – Business Resource Management</p>
                <p>the future is friendly ®</p>
              </Text>
            </Box>
          </ModalMessageMain>
        </ModalInner>
        <ButtonContainer>
          <Button onClick={handleSubmitAnotherBrpRequest}>
            Submit another request
          </Button>
          <Button variant="secondary" onClick={handleGoHome}>
            Go to home
          </Button>
        </ButtonContainer>
      </ModalMain>
    </Backdrop>
  );
};

BrpConfirmationBox.propTypes = {
  handleSubmitAnotherBrpRequest: PropTypes.func.isRequired
};

export default BrpConfirmationBox;
